/**
 * ============================================================
 * ProjectCard.js — Project Card for Projects/People Pages
 * ============================================================
 *
 * Props:
 *   project: {
 *     id,
 *     name,
 *     shortname,
 *     photo
 *   }
 *
 * Used in for current projects in:
 *   -> Projects.js (directory page)
 **/

import React from "react";
import { Link } from "react-router-dom";
import "./css/ProjectCard.css";

import { projectPhoto } from "../utils/mediaPaths";

// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function ProjectCard({ project }) {
  const { id, photo, name, shortname } = project;

  // Photo path
  const photoSrc = projectPhoto(photo);

  // Choose display name
  const displayName = name && name.length > 22 && shortname ? shortname : name;

  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <Link to={`/projects/${id}`} className="project-card-link">
      <div className="project-card">

        {/* ----- IMAGE ----- */}
        <div className="project-card-image-wrapper">
          <img
            src={photoSrc}
            alt={displayName}
            className="project-card-image"
          />
        </div>

        {/* ----- TITLE ----- */}
        <h3 className="project-card-title">{displayName}</h3>

      </div>
    </Link>
  );
}

export default ProjectCard;
